/* global App */
/* eslint-disable global-require */

import { sentry, errorTracker } from 'Modules/event';
import { getCurrentUserFromGlobal } from 'lib/current-user';
import browser from '@openclassrooms/utils/browser';
import { isDev } from 'Modules/environment';

App.build = {};

if (!isDev()) {
  errorTracker.use(sentry);
  errorTracker.install({
    user: getCurrentUserFromGlobal(),
  });
}

const { window } = browser;

window.jQuery = require('jquery');

window.$ = window.jQuery;

window.babelHelpers = require('./Vendors/babelHelpers');

require('./_nonCommonJs/vendors');
require('./_nonCommonJs/pre-legacyModules');

const init = require('./Inits/init').default;

require('./Bridges/OldModules/main');
require('./Widgets/ui/popin');

init.launch(
  require('Modules/selfXSS'),
  require('./Inits/Common/header'),
  require('./Inits/Common/smiley'),
  require('./Inits/Common/foldable'),
  require('./Inits/Common/enteringScreenElement'),
  require('./Inits/Common/dashboardTabs'),
  require('./Inits/Common/slidingItem'),
  require('./Inits/Common/ajaxlink'),
  require('./Inits/Common/sidebarWithContent'),
  require('./Inits/Common/popin'),
  require('./Inits/Common/uiWidgetInitializer'),
  require('Modules/modal'),
  require('Modules/imageCdn'),
  require('Modules/notifications'),
  require('Modules/onlineStatus'),
  require('Modules/smoothScrolling'),
  require('Modules/textarea-counter'),
  require('Modules/autocomplete'),
  require('Modules/user-content'),
  require('Modules/clipboard-copy'),
  require('Modules/dom/services/classToggler'),
  require('Modules/footer'),
  require('Modules/support'),
  require('Modules/main-header'),
  require('Modules/training-merchandising/services/initForumMerchandisingBanner')
);

require('./_nonCommonJs/post-legacyModules');
